module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if (data.features) { 
    ; __append("\n<div class=\"gl-map-popup\">\n	<div class=\"title\">Выберите адрес:</div>\n\n	")
    ;  Util.each(data.features, function (feature) { 
    ; __append("\n	<div class=\"row\">\n		<span class=\"action\" data-id=\"")
    ; __append(escapeFn( feature.id ))
    ; __append("\" on-click=\"onMapAddressClick\">")
    ; __append(escapeFn( feature.fullname ))
    ; __append("</span>\n	</div>\n	")
    ;  }) 
    ; __append("\n</div>\n")
    ;  } 
  }
  return __output.join("");

}